var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca onclick=\"{ toggleShown }\" href=\"javascript:void(0)\"\u003E\u003Ci class=\"{ fa: true, 'fa-eye': !shown, 'fa-eye-slash': shown }\"\u003E\u003C\u002Fi\u003E\u003Cinput class=\"token\" if=\"{ shown }\" value=\"{ token }\" readonly riot-style=\"width: { computeWidth() }px\" name=\"token-input\"\u003E\u003Cspan if=\"{ !shown }\"\u003EShow token\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./web/static/js/components/project-token/project-token.jade
// module id = 196
// module chunks = 0